import React, {useState} from 'react'
import { pdf } from '@react-pdf/renderer';
import { saveAs } from 'file-saver';
import { useDispatch, useSelector } from 'react-redux';
import { handlePDFGeneration, handleShowSaveUI } from '../../Redux/UIMenus/uiExportMenuSlice';
import { tableGenerator } from './tableGenerator';
import { GetPartialImpots } from '../../calcolatore/Calcolatore';
import PDFStructure from './PDFStructure';

import "../../styles/SaveUI.css"

// Schermata per il salvataggio del PDF al momento della pressione del pulsante di esportazione file
export default function SaveUI() {
  // Il nome del file da salvare
  const [inputValue, setInputValue] = useState("Il_Parco");  

  const lunghezza = useSelector(state => state.uiMainMenu.lunghezza);
  const larghezza = useSelector(state => state.uiMainMenu.larghezza);
  const ingresso = useSelector(state => state.uiMainMenu.ingresso);
  const coloreStrutture = useSelector(state => state.uiMainMenu.coloreStrutture);
  const pedanaSelected = useSelector(state => state.uiPedanaMenu.isVisible);
  const paraventiSelected = useSelector(state => state.uiParaventiMenu.isVisible);
  const ombrelloniSelected = useSelector(state => state.uiOmbrelloniMenu.isVisible);
  const cristalSelected = useSelector(state => state.uiCristalMenu.isVisible);
  const stepAltezza = useSelector(state => state.uiPedanaMenu.stepAltezza);
  const rivestimento = useSelector(state => state.uiPedanaMenu.rivestimento);
  const minigonna = useSelector(state => state.uiPedanaMenu.minigonna);
  const rampaDisabili = useSelector(state => state.uiPedanaMenu.rampaDisabili);
  const predisposizioneParaventi = useSelector(state => state.uiPedanaMenu.predisposizioneParaventi);
  const botole = useSelector(state => state.uiPedanaMenu.numeroBotole);
  const attacchiEsterni = useSelector(state => state.uiPedanaMenu.hasAttacchiEsterni);
  const tipoParaventi = useSelector(state => state.uiParaventiMenu.tipoParavento);
  const latiParaventi = useSelector(state => state.uiParaventiMenu.latiParaventi);
  const lunghezzaPerimetroParaventi = useSelector(state => state.uiParaventiMenu.lunghezzaParaventi);
  const porteParaventi = useSelector(state => state.uiParaventiMenu.porta);
  const genereOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.genereOmbrellone);
  const tipoOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.tipoOmbrellone);
  const ombrelloniHasSelezioneAutomatica = useSelector(state => state.uiOmbrelloniMenu.selezioneMisuraAutomatica);
  const misuraOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.misureOmbrellone);
  const misuraAutomaticaOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.misuraOmbrelloneAutomatica);
  const datiOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.dataOmbrelloni);
  const latiOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.latoOmbrelloni);
  const coloreTessuto = useSelector(state => state.uiOmbrelloniMenu.coloreTessutoOmbrelloni);
  const mantovana = useSelector(state => state.uiOmbrelloniMenu.mantovana);
  const grondaie = useSelector(state => state.uiOmbrelloniMenu.grondaie);
  const nastratura = useSelector(state => state.uiOmbrelloniMenu.nastratura);
  const velcro = useSelector(state => state.uiOmbrelloniMenu.velcro);
  const hasOmbrelloniContrapposti = useSelector(state => state.uiOmbrelloniMenu.ombrelloniContrapposti);
  const hasLed = useSelector(state => state.uiOmbrelloniMenu.hasLed);
  const ledKitType = useSelector(state => state.uiOmbrelloniMenu.tipoKitLed);
  const hasDimmerTelecomando = useSelector(state => state.uiOmbrelloniMenu.hasDimmerTel);
  const latiCristal = useSelector(state => state.uiCristalMenu.latiCristal);
  const kitPortaCristal = useSelector(state => state.uiCristalMenu.kitPortaCristal);
  const lunghezzaCristal = useSelector(state => state.uiCristalMenu.lunghezzaCristal);
  const sostegniCristal = useSelector(state => state.uiCristalMenu.totaleSostegni);  
  const prezzoTotale = useSelector(state => state.uiCalcoloMenu.totale);
  const exportedImagesArray = useSelector(state => state.uiExportMenu.exportedImages);
  
  let hasSuMisuraOmbrellone = false;
  let suMisuraDimension = 0; 
  const waterMarkImage = {src: `${process.env.PUBLIC_URL}/img/Watermark_Il_Parco.png`}; 
  
  const dispatch = useDispatch();
  
  // Prepara i dettagli per generare il file PDF
  const dataPrep = () => {
    if (ombrelloniHasSelezioneAutomatica && datiOmbrelloni.length > 0 && datiOmbrelloni[0].realDimension > datiOmbrelloni[0].mainDimension) {
      hasSuMisuraOmbrellone = true;
      suMisuraDimension = datiOmbrelloni[0].realDimension;
    } 
  }

  // Gestisce il nome di salvataggio del file
  const handleInputChange = (val) => {       
     setInputValue(val);          
  }  

  // Genera la tabella dei file PDF
  const generateTable = () => {
    tableGenerator(    
      lunghezza,
      larghezza,
      ingresso,
      coloreStrutture,
      pedanaSelected,
      paraventiSelected,
      ombrelloniSelected,
      cristalSelected,
      stepAltezza,
      rivestimento,
      minigonna,
      rampaDisabili,
      predisposizioneParaventi,
      botole,
      tipoParaventi,
      latiParaventi,
      lunghezzaPerimetroParaventi,
      porteParaventi,
      genereOmbrelloni,
      tipoOmbrelloni,
      ombrelloniHasSelezioneAutomatica,
      misuraOmbrelloni,
      misuraAutomaticaOmbrelloni,
      hasSuMisuraOmbrellone,
      suMisuraDimension,
      latiOmbrelloni,
      coloreTessuto,
      mantovana,
      grondaie,
      nastratura,
      velcro,
      attacchiEsterni,
      datiOmbrelloni.length,
      latiCristal,
      kitPortaCristal,
      lunghezzaCristal,
      sostegniCristal,
      GetPartialImpots(),
      prezzoTotale,
      exportedImagesArray,
      waterMarkImage,
      hasLed,
      ledKitType,
      hasDimmerTelecomando,
      hasOmbrelloniContrapposti
    );  
  }

  // Salva il file
  const handleClickSalva = async() => { 
    dispatch(handlePDFGeneration(true));
    // Prepara i dati per il PDF
    dataPrep();
    // Genera tabella
    generateTable();  
    // Genera il PDF  
    const blob = await pdf((
      <PDFStructure          
        title={inputValue}
      />
    )).toBlob();   
    dispatch(handlePDFGeneration(false));
    // Salva il PDF
    saveAs(blob, inputValue);       
    // Chiude la finestra 
    dispatch(handleShowSaveUI(false));
  }

  // Esce dalla schermata di salvataggio
  const handleClickAnnulla = () => {
    dispatch(handleShowSaveUI(false));
  }

  return (
    <div className='save__wrapper'>  
       <div className='save__main__content'>   
            <label className='save__main__label'> NOME PDF:
                <input className='save__main__input' type="text" value={inputValue} onChange={event => handleInputChange(event.target.value)} autoFocus />
            </label>    
              <button className='save__main__button__salva' onClick={handleClickSalva}>Salva</button>            
              <button className='save__main__button__annulla' onClick={handleClickAnnulla}>Annulla</button>
        </div>
      <div>        
  </div>
    </div>
  )
}
